import { profileKey } from '@staffedupusa/shared-components';
import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { useQuery } from 'react-query';

import {
  availableBookedSlotsKey,
  avaliableBookedBlocksRoute,
} from '@features/applicant';
import axiosInstance from '@server/axiosInstance';

type useGetBookedAvaliableSlotsProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
  inviteId?: number | null;
  jobListingId?: number | string| null;
  enabled: boolean;
};

export const useGetBookedAvaliableSlots = ({
  inviteId,
  jobListingId,
  enabled,
  setErrorText
}: useGetBookedAvaliableSlotsProps) => {
  const { data: avaliableBookedBlocks, isLoading: isAvaliableBookedBlocksLoading, } = useQuery({
    queryKey: [availableBookedSlotsKey, inviteId],
    queryFn: () => {
      const params = new URLSearchParams();

      params.append('block_invite_id', String(inviteId));
      jobListingId && params.append('job_listing_id', String(jobListingId));

      return axiosInstance
        .get(`${avaliableBookedBlocksRoute}`, { params })
        .then((res) => res.data);
    },
    enabled: Boolean(inviteId && enabled),
  });
  return {
    avaliableBookedBlocks,
    isAvaliableBookedBlocksLoading,
  };
};

